import { render, staticRenderFns } from "./AppQuotation.vue?vue&type=template&id=6cbf024a&"
import script from "./AppQuotation.vue?vue&type=script&lang=js&"
export * from "./AppQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports